import { Factory } from '@zaibot/fsa';

export const FOUND = Factory<{ noteId: number }, {}>('NOTE_LOCATOR_FOUND');
export const MISSING = Factory<{ noteId: number }, {}>('NOTE_LOCATOR_MISSING');
export const CLEAR = Factory<{ }, {}>('NOTE_LOCATOR_CLEAR');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/locator/actions.tsx